import type {PtSupplier} from "./paymentTermsDemoData";
import type {PtExclusions} from "./paymentTermsUtils";
import {TIER_LABEL, tierOf} from "./paymentTermsUtils";

function csvEscape(value: string | number | boolean): string {
    const s = String(value);
    if (s.includes(',') || s.includes('"') || s.includes('\n')) {
        return `"${s.replace(/"/g, '""')}"`;
    }
    return s;
}

export function exportPaymentTermsCsv(rows: PtSupplier[], exclusions: PtExclusions = {}) {
    const header = [
        'Parent supplier',
        'Opportunity type',
        'Total spend (12m)',
        'Weighted avg term (days)',
        'Target term (days)',
        'Term gap (days)',
        'Best existing term (days)',
        'Quick win opportunity',
        'Working capital opportunity',
        'Invoice count',
        'Immediate spend',
        'Below-target spend',
        'Posted-after-due spend',
        'Discount-at-risk spend',
        'Terms in use',
        'Meets policy',
        'Review status',
        'Exclusion reason',
    ];
    const lines = rows.map(r => [
        r.supplier,
        TIER_LABEL[tierOf(r)],
        r.spend,
        r.currentTerm,
        r.targetTerm,
        r.gapDays,
        r.bestExistingTerm ?? '',
        Math.round(r.quickWinOpportunity),
        Math.round(r.wcOpportunity),
        r.invoiceCount,
        r.immediateSpend,
        r.belowTargetSpend,
        r.postedAfterDueSpend,
        r.discountAtRiskSpend,
        r.distinctTermCount,
        r.meetsPolicy,
        exclusions[r.id] ? 'Excluded' : 'Potential',
        exclusions[r.id] ?? '',
    ].map(csvEscape).join(','));

    const csv = [header.join(','), ...lines].join('\n');
    const blob = new Blob([csv], {type: 'text/csv;charset=utf-8;'});
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'payment-terms-opportunities.csv';
    a.click();
    URL.revokeObjectURL(url);
}
